import { createReducer, on, Action } from '@ngrx/store';
import { IAnalyticalDatasetRequest, IAnalyticalDatasetRequestDetail } from '../../../models/analytical-dataset-request';
import * as AnalyticalDatasetRequestActions from '../actions/index';

const initialState: AnalyticalDatasetRequestState = {
  analyticalDatasetRequests: [],
  analyticalDatasetRequestDetail: null,
};

export interface AnalyticalDatasetRequestState {
  analyticalDatasetRequests: IAnalyticalDatasetRequest[];
  analyticalDatasetRequestDetail: IAnalyticalDatasetRequestDetail | null;
}

const analyticalDatasetRequestReducer = createReducer(
  initialState,
  on(AnalyticalDatasetRequestActions.AnalyticalDatasetRequestUiActions.GetAnalyticalDatasetRequests, (state) => {
    return {
      ...state,
    };
  }),

  on(
    AnalyticalDatasetRequestActions.AnalyticalDatasetRequestApiActions.GetAnalyticalDatasetRequestsSuccess,
    (state, { payload }) => {
      return {
        ...state,
        analyticalDatasetRequests: payload,
      };
    }
  ),

  on(
    AnalyticalDatasetRequestActions.AnalyticalDatasetRequestApiActions.GetAnalyticalDatasetRequestsFailure,
    (state) => {
      return {
        ...state,
      };
    }
  ),

  on(
    AnalyticalDatasetRequestActions.AnalyticalDatasetRequestUiActions.GetAnalyticalDatasetRequestDetail,
    (state) => {
      return {
        ...state,
        analyticalDatasetRequestDetail: null,
      };
    }
  ),

  on(
    AnalyticalDatasetRequestActions.AnalyticalDatasetRequestUiActions.SetAnalyticalDatasetRequestDetail,
    (state, { detail }) => {
      return {
        ...state,
        analyticalDatasetRequestDetail: detail,
      };
    }
  ),

  on(
    AnalyticalDatasetRequestActions.AnalyticalDatasetRequestApiActions.GetAnalyticalDatasetRequestDetailSuccess,
    (state, { payload }) => {
      return {
        ...state,
        analyticalDatasetRequestDetail: payload,
      };
    }
  ),

  on(
    AnalyticalDatasetRequestActions.AnalyticalDatasetRequestApiActions.GetAnalyticalDatasetRequestDetailFailure,
    (state) => {
      return {
        ...state,
      };
    }
  )
);

export function AnalyticalDatasetRequestReducer(
  state: AnalyticalDatasetRequestState = initialState,
  action: Action
): AnalyticalDatasetRequestState {
  return analyticalDatasetRequestReducer(state, action);
}

